<template>
    <div class="googleMapsPosition">
        <div ref="mapElement" style="height: 400px;"></div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class googleMapsPosition extends mixins(WithModel) {

    @Prop({
        default: {
            lat: 41.9028,
            long: 12.4964
        }
    }) center: OM.LatLong;

    declare localValue: OM.LatLong;
    map: any = null;

    async mounted(){
        this.init();
    }

    @Watch('localValue', { deep: true })
    onChange(){
        if(this.localValue){
            this.setMarkerPosition(this.localValue.lat, this.localValue.long);
        }
    }

    init(){
        this.map = new google.maps.Map(this.$refs.mapElement, {
            center: { lat: this.center.lat, lng: this.center.long },
            zoom: 8,
            mapId: new Date().getTime().toString()
        });
        
        let marker = null;

        if(this.localValue && this.localValue.lat && this.localValue.long){
            marker = new google.maps.Marker({
                map: this.map,
                position: { lat: this.localValue.lat, lng: this.localValue.long }
            });
        }

        this.setMarkerPosition = (lat: number, lng: number) => {
            if(marker){
                marker.setMap(null);
            }

            marker = new google.maps.Marker({
                map: this.map,
                position: { lat: lat, lng: lng }
            });

        }

        this.map.addListener("click", (e) => {
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();
            this.localValue.lat = lat;
            this.localValue.long = lng;

            this.setMarkerPosition(lat, lng);
        });
    }

    setMarkerPosition= (lat: number, lng: number) => {}

    beforeUnmount(){
        google.maps.event.clearInstanceListeners(this.map);
        this.map = null;
    }

}
</script>
